import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import { departmentKeyValue1, getWarehouseKeyValueList } from "../../../services/index";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Select from "react-select";
import { sortLatestFirst } from "../../utils/textUtils";
import { getDepStockClosingList, getStockClosingList } from "../../../services/Inventory/OtherServices";
import AddIcon from "@mui/icons-material/Add";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader";

const DepartmentStockClosingList = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [search, setSearch] = useState("");
  const [wareOptions, setWareOptions] = useState(null);
  const [selectedDepartment,setSelectedDepartment]=useState({
    value: "",
    label: "Select Department",
  })
  const[selectedDepartmentOptions,setSelectedDepartmentOptions]=useState(null)
  const [selectedWarehouse, setSelectedWarehouse] = useState({
    value: "",
    label: "Select Warehouse",
  });
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "STOCK CODE",
      cell: (row) => row.code,
      style: { color: "#007bff" },
    },
    {
      name: "CREATION DATE",
      cell: (row) => row.createdAt,
    },
  ];

  useEffect(() => {
    if (!wareOptions) {
      getWarehouseKeyValueList().then((res) => {
        if (res.errorCode === 0) {
          const options = res.responsePacket?.map((d) => ({
            value: d.key,
            label: d.value,
          }));
          setWareOptions(options);
          setSelectedWarehouse(options[0]);
        } else {
          toast(res.message);
        }
      });
    }
    departmentKeyValue1().then((res) => {
      if (res.errorCode === 0) {
          const options = res.responsePacket?.map((d) => ({
              value: d.key,
              label: d.value,
          }));
          setSelectedDepartmentOptions(options)
          setSelectedDepartment(options[0])
      }
  })
  }, []);

  useEffect(() => {

    if (selectedWarehouse && selectedWarehouse.value !== ""&& selectedDepartment&& selectedDepartment.value!==""){
      setSearch("");
      getList();
    }
  }, [selectedWarehouse,selectedDepartment]);

  const getList = () => {
    setLoading(true);
    getDepStockClosingList(selectedWarehouse?.value,selectedDepartment?.value)
      .then((res) => {
        if (res.errorCode === 0) {
          let temp = sortLatestFirst(res.responsePacket, "createdAt");
          setList(temp);
          setFilteredList(temp);
        } else {
          toast.error(res.message);
        }
        setLoading(false);
      })
      .catch((error) => setLoading(false));
  };

  useEffect(() => {
    if (list) {
      const result = list.filter((data) => {
        return (
          data.code.toLowerCase().includes(search.toLowerCase()) ||
          data.createdAt.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredList(result);
    }
  }, [search]);

  const handleSelectDepartement = (e) => {
    setSelectedDepartment(e);
};


  return (
    <>
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0 font-size-18 font-weight-bolder text-uppercase w-100">
           Department Stock closing list
          </h3>
        </div>
        <>
          {filteredList && (
            <DataTable
              columns={columns}
              data={filteredList}
              theme="light"
              pagination
              fixedHeader
              pointerOnHover={true}
              highlightOnHover={true}
              onRowClicked={(data) =>
                navigate(
                  `/departmentstockClosing/${data.uuid}/${data.code}`
                )
              }
              subHeader
              subHeaderComponent={
                <>
                  <div
                    className="d-flex align-items-center justify-content-between w-100"
                    style={{ zIndex: "3" }}
                  >
                    <div style={{display:"flex" ,padding:"20px"}}>
                      <Select
                        value={selectedWarehouse}
                        options={wareOptions}
                        onChange={(e) => setSelectedWarehouse(e)}
                        className="text-left"
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "200px", // Set width for warehouse select
                          }),
                        }}
                      />
                        <Select value={selectedDepartment}
                         isDisabled={!selectedDepartment} 
                         options={selectedDepartmentOptions}
                          onChange={(e) => handleSelectDepartement(e)}
                          className="text-left"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: "200px", 
                              marginLeft:"20px"// Set width for warehouse select
                            }),
                          }}
                           />
                    </div>
                    
                    
                    <div className="d-flex align-items-center">
                      <div className="input-group paginationSearchInput mr-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <SearchRoundedIcon />
                          </span>
                        </div>
                        <input
                          autoComplete="off"
                          className="ember-text-field ember-view form-control"
                          type="text"
                          placeholder={"Search..."}
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          style={{ maxWidth: "200px" }}
                        />
                      </div>

                      <Link to="/departmentstockClosing/new">
                        <button
                          id="ember5839"
                          className="tooltip-container ember-view btn btn-primary d-flex align-items-center height-38 mx-2 "
                          type="button"
                        >
                          <AddIcon />
                          New
                        </button>
                      </Link>
                    </div>
                  </div>
                </>
              }
              progressPending={loading}
              progressComponent={<Loader />}
            />
          )}
        </>
      </div>
      <Toaster />
    </>
  );
};

export default DepartmentStockClosingList;
